import { render, staticRenderFns } from "./TermoComparaUltimosDados.vue?vue&type=template&id=5e1e4f02&scoped=true&"
import script from "./TermoComparaUltimosDados.vue?vue&type=script&lang=js&"
export * from "./TermoComparaUltimosDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e4f02",
  null
  
)

export default component.exports